import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import VueGtag from "vue-gtag";
import store from "./store";
import utils from "./common/utils";
import { i18n } from "./i18n";

// import VueMeta from "vue-meta";
// Vue.use(VueMeta);

import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);

import VTooltip from "v-tooltip";
Vue.use(VTooltip);
if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
  Vue.use(VueGtag, { config: { id: "G-G0C5LP1PRM" } }, router);
}
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);

Vue.config.productionTip = false;
Vue.config.devtools = false;

import jQuery from "jquery";
global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

// デザイン
import "./assets/css/reset.css";
import "./assets/css/common.css";
import "./assets/css/content.css";
import "./assets/css/swiper.min.css";
import "./assets/css/magnific-popup.css";
import "./assets/css/loading.css";
import "./assets/css/tooltip.scss";
import "./assets/js/main";
import "./assets/js/jquery.easing";
import "./assets/css/custom.css";
import "./assets/css/topapp.css";

Vue.mixin(utils);

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
